import React from 'react';
import ContactForm from '../Shared/ContactForm/ContactForm';

const Contact = () => {
    return (
        <div className="mt-5">
            
            <ContactForm></ContactForm>

            <h3 className="text-center text-light m-5">Contact with Social Media</h3>
            <h3 className="followMe-icon text-center">
              <a target="_blank" href="https://www.linkedin.com/in/iasir-arafat-riaz-a5a4811b8/">
                <i class="fab fa-linkedin"></i> -{"  "}
              </a>
              <a target="_blank" href="https://github.com/Iasir-Arafat-riaz">
                <i class="fab fa-github"></i> -{" "}
              </a>
              <a target="_blank" href=" https://twitter.com/Arafat_Riaz_CSE">
                <i class="fab fa-twitter"></i> - {" "}
              </a>
              <a target="_blank" href="https://www.facebook.com/profile.php?id=100059987543734">
                <i class="fab fa-facebook"></i>{" "}
              </a>
            </h3>

        </div>
    );
};

export default Contact;